export const selectedFolderNodeScreenReaderOnlyText = "ZG1NAd";
export default {selectedFolderNodeScreenReaderOnlyText};